<template>
    <div class="container my-5">

        <div class="row justify-content-center">
            <div class="col-md-12">

                <form class="form-register">

                    <h1 class="text-center mb-4">{{ translate.login.phoneVerification.title }}</h1>

                    <p>{{ translate.login.phoneVerification.subTitle }}</p>

                    <div class="form-group">

                        <span class="error-input-container">
                            <input class="form-control" id="inputEmailOrPhone" :placeholder="translate.login.phoneVerification.enterCodeHere"
                                   type="number" v-model="code">
                        </span>

                    </div>

                    <button-with-loading-component class="btn btn-primary btn-block "
                                                   type="submit"
                                                   :text="translate.login.phoneVerification.verify"
                                                   :loading="loading"
                                                   @click.native.prevent="onSubmit"
                    ></button-with-loading-component>
                </form>

                <h2 class="text-center mt-5">{{ translate.login.phoneVerification.reSendTitle }}</h2>

                <p v-if="counter !== undefined">{{ translate.login.phoneVerification.reSendSubtitle }} {{counter}}</p>

                <button-with-loading-component class="btn btn-primary btn-block"
                                               type="submit"
                                               :disabled="!canResend"
                                               :text="translate.login.phoneVerification.reSend"
                                               :loading="loadingResend"
                                               @click.native.prevent="resendButton"
                ></button-with-loading-component>

            </div>
        </div>

    </div>
</template>

<script>

import api from "@/core/api";
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";

const data = () => {
    return {
        code: '',
        loading: false,
        loadingResend: false,
        canResend: false,
        counter: undefined,
    }
};

async function onSubmit() {
    const [err, response] = await to(
        api.user.verifyCode(this.userIdHash, this.code)
    );

    if (err) {
        return toastr.error(this.translate.home.errorCommon);
    }

    const isSuccess = _.get(response, 'data.success', false);

    if (isSuccess) {
        toastr.success(_.get(response, 'data.msg', ''));
        window.location.href = regionRelativeUrl('/users/login/' + this.userIdHash);
    } else {
        toastr.error(_.get(response, 'data.msg', ''));
    }
}

async function resendButton() {
    const [err, response] = await to(
        api.user.resendCode(this.userIdHash)
    );

    if (err) {
        toastr.error(this.translate.home.errorCommon);
    }

    const isSuccess = _.get(response, 'data.success', false);

    if (isSuccess) {
        toastr.success(_.get(response, 'data.msg', ''));
        this.fetchData();
    } else {
        toastr.error(_.get(response, 'data.msg', ''));
    }
}

async function fetchData() {
    const [err, response] = await to(
        api.user.getVerifyNumberData(this.userIdHash)
    );

    if (err) {
        toastr.error(this.translate.home.errorCommon);
    }

    this.canResend = _.get(response, 'data.canResend', false);

    if (!this.canResend) {
        let timeout = _.get(response, 'data.timeout', false);
        const that = this;

        function myTimer() {
            that.counter = timeout--;
            if (that.counter <= 0) {
                that.canResend = true;
                clearInterval(myVar);
            }
        }

        let myVar = setInterval(myTimer, 1000);
    }
}

async function mounted() {
    this.fetchData();
}

export default {
    props: ['userIdHash'],
    mounted,
    data,
    methods: {
        onSubmit,
        resendButton,
        fetchData
    },
    computed: {
        ...mapState([
            'translate'
        ]),
    },
};
</script>
